// public pages
export const HOME = '/';
export const ERROR = '/error/:code';
export const LOGIN = '/login-page';

export const SUBSCRIPTION_PLAN = '/subscription-plans';
export const SUBSCRIPTION_PLAN_2 = '/subscription-plans-2';
// TODO: delete if client is agreed to pdf version
// export const TERMS_AND_CONDITIONS = '/terms-and-conditions';

export const WORKSPACE = '/workspace';
export const ACCOUNT_SETTINGS = '/settings';
export const ACCOUNT_SUBSCRIPTIONS = '/subscriptions';
export const ACCOUNT_PAYMENT_INFO = '/payment-info';

export const HELP_AND_SUPPORT = 'https://growexa.com/help-and-support';

export const CONTACT_US_MAIL = 'support@growexa.com';

export const ONE_PAGE_PROTECTED = '/one-page-protected';

export const BUSINESS_TOOL_BASIC_NAME = 'business-tool';
export const BUSINESS_TOOL_BASIC = `/${BUSINESS_TOOL_BASIC_NAME}`;
export const BUSINESS_TOOL = `${BUSINESS_TOOL_BASIC}/:id`;
export const VIEW_PDF = `${BUSINESS_TOOL}/view-pdf`;

export const ONE_PAGE_VIEW = `${BUSINESS_TOOL}/view-one-page`;
